

export const formStyles = {
  wrapper: {
    padding: "24px 20px 40px",
    maxWidth: 720,
    margin: "0 auto",
    fontFamily: "'DM Sans', sans-serif",
    color: "#f1f5f9",
  },
  title: { fontSize: "1.15rem", fontWeight: 700, color: "#f1f5f9", marginBottom: 4, marginTop: 0 },
  subtitle: { fontSize: "0.8rem", color: "rgba(255,255,255,0.45)", marginBottom: 24, marginTop: 0 },
  section: { marginBottom: 28 },
  sectionLabel: { fontSize: "0.75rem", fontWeight: 600, color: "#22d3ee", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 14, marginTop: 0 },
  fieldGrid2: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 },
  fieldGrid3: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 14 },
  fieldFull: { display: "flex", flexDirection: "column", gap: 5, marginBottom: 14 , marginTop: 10},
  fieldGroup: { display: "flex", flexDirection: "column", gap: 5 },
  label: { fontSize: "0.78rem", fontWeight: 500, color: "rgba(255,255,255,0.6)" },
  input: {
    padding: "10px 14px", borderRadius: 10, border: "1px solid rgba(255,255,255,0.15)",
    background: "rgba(255,255,255,0.07)", color: "#f1f5f9", fontSize: "0.85rem",
    fontFamily: "'DM Sans', sans-serif", outline: "none", transition: "border-color 0.2s ease",
    width: "100%", boxSizing: "border-box",
  },
  textarea: {
    padding: "12px 14px", borderRadius: 10, border: "1px solid rgba(255,255,255,0.15)",
    background: "rgba(255,255,255,0.07)", color: "#f1f5f9", fontSize: "0.85rem",
    fontFamily: "'DM Sans', sans-serif", outline: "none", resize: "vertical",
    minHeight: 80, lineHeight: 1.5, width: "100%", boxSizing: "border-box",
  },
  textareaLarge: {
    padding: "12px 14px", borderRadius: 10, border: "1px solid rgba(255,255,255,0.15)",
    background: "rgba(255,255,255,0.07)", color: "#f1f5f9", fontSize: "0.85rem",
    fontFamily: "'DM Sans', sans-serif", outline: "none", resize: "vertical",
    minHeight: 140, lineHeight: 1.5, width: "100%", boxSizing: "border-box",
  },
  select: {
    padding: "10px 14px", borderRadius: 10, border: "1px solid rgba(255,255,255,0.15)",
    background: "rgba(255,255,255,0.07)", color: "#f1f5f9", fontSize: "0.85rem",
    fontFamily: "'DM Sans', sans-serif", outline: "none", cursor: "pointer",
    appearance: "none", WebkitAppearance: "none", width: "100%", boxSizing: "border-box",
  },
  optionStyle: { background: "#1e293b", color: "#f1f5f9" },

  /* Table styles (uniform/vendor) */
  table: { width: "100%", borderCollapse: "separate", borderSpacing: "0 6px" },
  th: { fontSize: "0.72rem", fontWeight: 600, color: "rgba(255,255,255,0.5)", textTransform: "uppercase", letterSpacing: "0.06em", padding: "0 8px 8px", textAlign: "left" },
  thRight: { fontSize: "0.72rem", fontWeight: 600, color: "rgba(255,255,255,0.5)", textTransform: "uppercase", letterSpacing: "0.06em", padding: "0 8px 8px", textAlign: "right" },
  tdFirst: { padding: "10px 12px", background: "rgba(255,255,255,0.03)", borderTop: "1px solid rgba(255,255,255,0.06)", borderBottom: "1px solid rgba(255,255,255,0.06)", borderLeft: "1px solid rgba(255,255,255,0.06)", borderRadius: "10px 0 0 10px" },
  td: { padding: "10px 8px", background: "rgba(255,255,255,0.03)", borderTop: "1px solid rgba(255,255,255,0.06)", borderBottom: "1px solid rgba(255,255,255,0.06)" },
  tdLast: { padding: "10px 12px", background: "rgba(255,255,255,0.03)", borderTop: "1px solid rgba(255,255,255,0.06)", borderBottom: "1px solid rgba(255,255,255,0.06)", borderRight: "1px solid rgba(255,255,255,0.06)", borderRadius: "0 10px 10px 0", textAlign: "right" },
  productName: { fontSize: "0.82rem", color: "#f1f5f9", fontWeight: 500 },
  cost: { fontSize: "0.82rem", color: "rgba(255,255,255,0.55)", textAlign: "right" },
  qtyInput: { padding: "8px 10px", borderRadius: 8, border: "1px solid rgba(255,255,255,0.15)", background: "rgba(255,255,255,0.07)", color: "#f1f5f9", fontSize: "0.85rem", fontFamily: "'DM Sans', sans-serif", outline: "none", width: 54, textAlign: "center", boxSizing: "border-box" },
  selectSmall: { padding: "8px 10px", borderRadius: 8, border: "1px solid rgba(255,255,255,0.15)", background: "rgba(255,255,255,0.07)", color: "#f1f5f9", fontSize: "0.82rem", fontFamily: "'DM Sans', sans-serif", outline: "none", width: "100%", cursor: "pointer", appearance: "none", WebkitAppearance: "none", boxSizing: "border-box" },
  rowTotal: { fontSize: "0.85rem", fontWeight: 600, color: "#22d3ee" },
  totalRow: { display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 24, padding: "16px 12px", marginTop: 8, borderTop: "1px solid rgba(34,211,238,0.2)" },
  totalLabel: { fontSize: "0.85rem", fontWeight: 600, color: "rgba(255,255,255,0.55)" },
  totalValue: { fontSize: "1.1rem", fontWeight: 700, color: "#22d3ee" },

  /* Checkbox */
  checkboxRow: { display: "flex", gap: 24, marginBottom: 14 },
  checkboxLabel: { display: "flex", alignItems: "center", gap: 8, fontSize: "0.85rem", color: "#f1f5f9", cursor: "pointer" },
  checkbox: { width: 18, height: 18, accentColor: "#22d3ee", cursor: "pointer" },

  /* Signature pad area */
  signatureSection: { marginBottom: 20 },
  signatureGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 },
  signatureBlock: { display: "flex", flexDirection: "column", gap: 8 },
  signatureLabel: { fontSize: "0.78rem", fontWeight: 600, color: "rgba(255,255,255,0.6)" },

  /* Misc */
  disclaimer: { fontSize: "0.72rem", color: "rgba(255,255,255,0.35)", lineHeight: 1.6, padding: "16px 0", borderTop: "1px solid rgba(255,255,255,0.06)", marginTop: 16 },
  btnRow: { display: "flex", gap: 12, marginTop: 20 },
  resetBtn: { padding: "14px 20px", borderRadius: 12, border: "1px solid rgba(255,255,255,0.12)", background: "rgba(255,255,255,0.04)", color: "rgba(255,255,255,0.55)", fontSize: "0.85rem", fontWeight: 500, fontFamily: "'DM Sans', sans-serif", cursor: "pointer", transition: "all 0.2s ease" },
  error: { marginTop: 12, padding: "10px 14px", borderRadius: 10, background: "rgba(239,68,68,0.1)", border: "1px solid rgba(239,68,68,0.2)", color: "#f87171", fontSize: "0.82rem" },
  spinner: { display: "inline-block", width: 16, height: 16, border: "2px solid rgba(255,255,255,0.3)", borderTopColor: "#fff", borderRadius: "50%", animation: "spin 0.6s linear infinite" },
  spinKeyframes: `@keyframes spin { to { transform: rotate(360deg); } }`,
  divider: { height: 1, background: "rgba(255,255,255,0.06)", margin: "24px 0", border: "none" },
  pageLabel: { fontSize: "0.7rem", fontWeight: 600, color: "rgba(255,255,255,0.3)", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 16, marginTop: 0 },
};

export const downloadBtnStyle = (isValid) => ({
  flex: 1, padding: "14px 24px", borderRadius: 12, border: "none",
  background: isValid ? "linear-gradient(135deg, #22d3ee 0%, #3b82f6 100%)" : "rgba(255,255,255,0.06)",
  color: isValid ? "#fff" : "rgba(255,255,255,0.25)", fontSize: "0.9rem", fontWeight: 600,
  fontFamily: "'DM Sans', sans-serif", cursor: isValid ? "pointer" : "not-allowed",
  boxShadow: isValid ? "0 4px 20px rgba(34,211,238,0.25)" : "none",
  transition: "all 0.3s ease", display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
});

export const DownloadIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);

export const requiredInput = (value) => ({
  ...formStyles.input,
  border: value?.trim()
    ? "1px solid rgba(255,255,255,0.15)"
    : "1px solid rgba(239,68,68,0.5)",
});

export const requiredTextarea = (value, large = false) => ({
  ...(large ? formStyles.textareaLarge : formStyles.textarea),
  border: value?.trim()
    ? "1px solid rgba(255,255,255,0.15)"
    : "1px solid rgba(239,68,68,0.5)",
});